import { KpiCard, KpiGrid, KpiLabel, KpiValue } from "../style";

export default function KPICards({ text, totals }) {
  const t = totals || {
    total: 0,
    downloaded: 0,
    published: 0,
    downloadedNotPublished: 0,
  };
  const cards = [
    { key: "total", label: text.kpis.total, value: t.total },
    { key: "downloaded", label: text.kpis.downloaded, value: t.downloaded },
    { key: "published", label: text.kpis.published, value: t.published },
    {
      key: "downloadedNotPublished",
      label: text.kpis.downloadedNotPublished,
      value: t.downloadedNotPublished,
      warning: true,
    },
  ];
  return (
    <KpiGrid>
      {cards.map((c) => (
        <KpiCard key={c.key} className={c.warning ? "warning" : ""}>
          <KpiLabel>{c.label}</KpiLabel>
          <KpiValue className={c.warning ? "warning" : ""}>{c.value ?? 0}</KpiValue>
        </KpiCard>
      ))}
    </KpiGrid>
  );
}
